import { Link } from 'react-router-dom';
import { AREE } from '../../constants/areas';
import Checkbox from '../nav/Checkbox';
import StatusBadge from '../nav/StatusBadge';

const FADE_TRANS = 'opacity 280ms cubic-bezier(0.22, 1, 0.36, 1)';

/**
 * TappeSection — lista checkable di tappe/abitudini del periodo.
 *
 * Props:
 *   - targets        : array filtrato di target periodo (solo kr tipo tappa/abitudine)
 *   - krById         : map krId → kr
 *   - onToggle(t,nv) : toggle ottimistico
 *   - onChipAreaClick(area) : applica filtro area al click del chip
 */
export default function TappeSection({ targets, krById, onToggle, onChipAreaClick }) {
  if (targets.length === 0) return null;
  return (
    <section className="mb-12" data-testid="section-tappe">
      <h2 className="font-display text-xl md:text-2xl tracking-tight mb-4">Tappe · abitudini</h2>
      <ul className="divide-y divide-linesoft border-b border-linesoft">
        {targets.map((t) => {
          const kr = krById[t.key_result_id];
          const areaKey = (kr.area || '').toLowerCase();
          const meta = AREE[areaKey] || { color: 'var(--qp-ink)' };
          return (
            <li key={t.id} className="py-3 flex items-center gap-3" data-testid={`row-tappa-${t.id}`}>
              <Checkbox
                checked={t.raggiunto}
                onToggle={(next) => onToggle(t.id, next)}
                size={18}
                label={`${kr.titolo} · ${t.etichetta}`}
                testid={`toggle-tappa-${t.id}`}
              />
              <StatusBadge stato={t.raggiunto ? 'raggiunto' : 'on_track'} />
              {areaKey && AREE[areaKey] && (
                <button
                  type="button"
                  onClick={() => onChipAreaClick(areaKey)}
                  className="font-mono text-[10px] uppercase tracking-[0.15em] px-1.5 py-0.5 border shrink-0 hover:opacity-70 cursor-pointer"
                  style={{ borderColor: meta.color, color: meta.color }}
                  title={`Filtra per ${AREE[areaKey].label}`}
                  data-testid={`periodo-tappa-area-chip-${t.id}`}
                >
                  {AREE[areaKey].label.slice(0, 3)}
                </button>
              )}
              <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-mute">{kr.tipo}</span>
              <Link
                to={`/obiettivo/${kr.obiettivo_id}`}
                className="flex-1 font-body text-sm hover:underline"
                style={{
                  color: t.raggiunto ? 'var(--qp-text-mute)' : meta.color,
                  textDecoration: t.raggiunto ? 'line-through' : 'none',
                  opacity: t.raggiunto ? 0.5 : 1,
                  transition: FADE_TRANS,
                }}
              >
                {kr.titolo}
              </Link>
              <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-mute shrink-0">{t.etichetta}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
